export const INIT_STATE = 'INIT_LOGIN_STATE';

export const POST_LOGIN_DATA_LOADING = 'POST_LOGIN_DATA_LOADING';
export const POST_LOGIN_DATA_SUCCESS = 'POST_LOGIN_DATA_SUCCESS';
export const POST_LOGIN_DATA_ERROR = 'POST_LOGIN_DATA_ERROR';

export const POST_REQUEST_OTP_LOADING = 'POST_REQUEST_OTP_LOADING';
export const POST_REQUEST_OTP_SUCCESS = 'POST_REQUEST_OTP_SUCCESS';
export const POST_REQUEST_OTP_ERROR = 'POST_REQUEST_OTP_ERROR';